/*
 * Filename: d:\projects\AutoFiFront\src\Theme\Component\PaginateStyled.tsx
 * Path: d:\projects\AutoFiFront
 * Created Date: Thursday, February 16th 2023, 10:39:54 am
 * Author: Jonathan MAZAT
 *
 * Copyright (c) 2023 Autobuy SAS
 */

import ReactPaginate from 'react-paginate';
import styled from "styled-components";

const PaginateStyled = styled(ReactPaginate).attrs(props => {return ({
        bgColor: props.bgColor,
        className: props.pagination,
        activeClassName: `activeClassName`,
        pageClassName: `pageClassName`,
        breakClassName: props.breakClassName,
        previousClassName: props.previousClassName,
        previousLinkClassName: `textLinkClassName`,
        nextLinkClassName: `textLinkClassName`,
        disabledClassName: props.disabledClassName,
        pageLinkClassName: "page-link",
        disabledLinkClassName: props.disabledLinkClassName,
        forcePage: props.forcePage,
        breakLabel: props.breakLabel,
        onPageChange: props.onPageChange,
        marginPagesDisplayed: props.marginPagesDisplayed,
        pageRangeDisplayed: props.pageRangeDisplayed,
        pageCount: props.pageCount,
        nextLabel: props.nextLabel,
        previousLabel: props.previousLabel,
        renderOnZeroPageCount: props.renderOnZeroPageCount
})})`
margin-bottom: 1rem;
.activeClassName,
.pageClassName:hover,
.textLinkClassName:hover{
    background-color: ${props => props.bgColor == "CITYCAR" ? props.theme.colors.second : props.bgColor == "SUV" ? props.theme.colors.third : props.bgColor == "UTILITY" ? props.theme.colors.fourth : props.bgColor == "SEDAN" ? props.theme.colors.fifth : props.bgColor == "BREAK" ? props.theme.colors.sixth : props.theme.colors.first};
    border-radius: 5px;
    color: white;
    cursor: pointer;
}
.pageClassName{
    margin: 0.3rem;
    width: 2rem;
    text-align: center;
    color: white;
}
.textLinkClassName {
    color: white;
}
`;

export default PaginateStyled;
